/**
 * @generated SignedSource<<2974c915cfaf5d189a1b919977a864a8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FooterBottomRow_viewer$data = {
  readonly user?: {
    readonly " $fragmentSpreads": FragmentRefs<"DisplaySettingsCta_user">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"DisplaySettingsCta_viewer">;
  readonly " $fragmentType": "FooterBottomRow_viewer";
};
export type FooterBottomRow_viewer$key = {
  readonly " $data"?: FooterBottomRow_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"FooterBottomRow_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "FooterBottomRow_viewer",
  "selections": [
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "DisplaySettingsCta_user"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DisplaySettingsCta_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "645c8caf07c02919e9c34b371199e483";

export default node;
